module.exports = __webpack_public_path__ + "img/eg-9-01.35ddfd78.png";